const lang = {
  'frontend.global.operation.confirm': '確認',
  'frontend.global.operation.ok': '確定',
  'frontend.global.operation.save': '儲存',
  'frontend.global.operation.finished': '完成',
  'frontend.global.operation.cancel': '取消',
  'frontend.global.operation.signin': '登入',
  'frontend.global.operation.signout': '登出',
  'frontend.global.operation.addservicecontent': '新增服務項目',
  'frontend.global.operation.addproject': '新增專案',
  'frontend.global.operation.adduser': '新增人員',
  'frontend.global.operation.removeuser': '刪除使用者',
  'frontend.global.operation.updateimage': '更新圖片',
  'frontend.global.operation.logout': '登出',

  'frontend.global.property.websiteenv': '測試版',
  'frontend.global.property.websitetitle': '後台管理系統',
  'frontend.global.property.username': '帳號',
  'frontend.global.property.password': '密碼',
  'frontend.global.property.or': '或',
  'frontend.global.property.validate': '驗證中',
  'frontend.global.property.userlogout': '登出',

  'frontend.global.route.home': '首頁管理',
  'frontend.global.route.service': '服務管理',
  'frontend.global.route.project': '專案管理',
  'frontend.global.route.contact': '聯絡資訊',
  'frontend.global.route.user': '使用者管理',

  'frontend.global.hint.username': '輸入帳號',
  'frontend.global.hint.password': '輸入密碼',
  'frontend.global.hint.searchproject': '搜尋專案',

  'frontend.global.tips.invalidpassword': '錯誤的密碼',
  'frontend.global.tips.invalidaccount': '空的帳號',

  'frontend.global.error.0000': 'Oops !',

  'frontend.local.home.title': '首頁管理',
  'frontend.local.home.blocktitletitle': '首頁標題設定',
  'frontend.local.home.propertytitle': '主標題（中文）',
  'frontend.local.home.propertytitlehint': '請輸入首頁標題',
  'frontend.local.home.propertytitleen': 'Hero title (English) ',
  'frontend.local.home.propertytitleenhint': 'Please enter title',
  'frontend.local.home.blocktitlehomeprojecttitle': '首頁專案',
  'frontend.local.home.blocktitlehomeprojectcardtitle': '選擇專案',
  'frontend.local.home.selectprojecttitle': '選擇 {0} 的專案',

  'frontend.local.service.title': '服務管理',
  'frontend.local.service.tabletitletitle': '服務名稱',
  'frontend.local.service.tabletitledesc': '描述',
  'frontend.local.service.propertyname': '服務名稱',
  'frontend.local.service.propertynamehint': '請輸入服務名稱',
  'frontend.local.service.propertynameen': 'Service Name',
  'frontend.local.service.propertynameenhint': 'Please enter Service Name',
  'frontend.local.service.propertyndesc': '描述',
  'frontend.local.service.propertyndeschint': '請輸入描述',
  'frontend.local.service.propertydesen': 'Description',
  'frontend.local.service.propertydesenhint': 'Please enter the description',
  'frontend.local.service.detailcreatetitle': '新增服務項目',
  'frontend.local.service.detailedittitle': '編輯服務項目',

  'frontend.local.project.title': '專案管理',
  'frontend.local.project.tableimage': '專案圖片',
  'frontend.local.project.tabletitle': '標題',
  'frontend.local.project.tablectime': '建立時間',
  'frontend.local.project.detailcreatetitle': '新增專案項目',
  'frontend.local.project.detailedittitle': '編輯專案項目',
  'frontend.local.project.blocktitleimage': '專案顯圖',
  'frontend.local.project.addimage': '新增圖片',
  'frontend.local.project.blocktitleinfo': '專案資訊',
  'frontend.local.project.propertytitle': '專案名稱',
  'frontend.local.project.propertytitlehint': '請輸入地點',
  'frontend.local.project.propertytitleen': 'Project Name',
  'frontend.local.project.propertytitleenhint': 'Please enter the project name',
  'frontend.local.project.propertydesc': '專案描述',
  'frontend.local.project.propertydeschint': '請輸入描述',
  'frontend.local.project.propertydescen': 'Project Description',
  'frontend.local.project.propertydescenhint': 'Please enter the description',
  'frontend.local.project.propertytime': '時間',
  'frontend.local.project.propertytimehint': '請選擇時間',
  'frontend.local.project.propertylocation': '地點',
  'frontend.local.project.propertylocationhint': '請輸入地點',
  'frontend.local.project.propertylocationen': 'Location',
  'frontend.local.project.propertylocationenhint': 'Please enter the location.',
  'frontend.local.project.propertycurator': '策展人',
  'frontend.local.project.propertycuratorhint': '請輸入策展人',
  'frontend.local.project.propertycuratoren': 'Curator',
  'frontend.local.project.propertycuratorenhint': `Please enter the curator's name`,
  'frontend.local.project.blocktitlecontent': '專案內容',
  'frontend.local.project.propertycontent': '中文內容',
  'frontend.local.project.propertycontenthint': '請輸入中文內容',
  'frontend.local.project.propertycontenten': '英文內容',
  'frontend.local.project.propertycontentenhint': 'English Content',

  'frontend.local.contact.title': '聯絡資訊',
  'frontend.local.contact.blocktitletitle': '標題設定',
  'frontend.local.contact.propertytitle': '主標題（中文）',
  'frontend.local.contact.propertytitlehint': '請輸入標題',
  'frontend.local.contact.propertytitleen': 'Hero title (English) ',
  'frontend.local.contact.propertytitleenhint': 'Please enter title',
  'frontend.local.contact.blocktitlecontractinfo': '聯絡資訊',
  'frontend.local.contact.propertyaddress': '地址（中文）',
  'frontend.local.contact.propertyaddresshint': '請輸入地址',
  'frontend.local.contact.propertyaddressen': 'Address',
  'frontend.local.contact.propertyaddressenhint': 'Please enter address',
  'frontend.local.contact.propertyemail': 'Email',
  'frontend.local.contact.propertyemailhint': '請輸入 Email',
  'frontend.local.contact.propertyvatnumber': '統編 / VAT Number',
  'frontend.local.contact.propertyvatnumberhint': '請輸入統編',
  'frontend.local.contact.blocktitlesocialinfo': '社群媒體',
  'frontend.local.contact.propertyfb': 'FB',
  'frontend.local.contact.propertyfbhint': '請輸入 FB',
  'frontend.local.contact.propertyig': 'IG',
  'frontend.local.contact.propertyighint': '請輸入 IG',
  'frontend.local.contact.propertyx': 'X',
  'frontend.local.contact.propertyxhint': '請輸入 X',

  'frontend.local.user.title': '使用者管理',
  'frontend.local.user.tabletitletitle': '帳號',
  'frontend.local.user.tabletitlectime': '建立時間',
  'frontend.local.user.tabletitlemtime': '更新時間',
  'frontend.local.user.tabletitlepermission': '權限',
  'frontend.local.user.propertyusername': '帳號',
  'frontend.local.user.propertyusernamehint': '請輸入帳號',
  'frontend.local.user.propertypassword': '密碼',
  'frontend.local.user.propertypasswordhint': '請輸入密碼',
  'frontend.local.user.propertypermission': '權限',
  'frontend.local.user.propertypermissionhint': '請選擇權限',
  'frontend.local.user.propertyctime': '建立時間',
  'frontend.local.user.propertymtime': '更新時間',
  'frontend.local.user.detailcreatetitle': '新增使用者',
  'frontend.local.user.detailedittitle': '編輯使用者',
  'frontend.local.user.permissionoptionadmin': '管理者',
  'frontend.local.user.permissionoptionnormal': '一般使用者',

  'frontend.local.component.tablepager.count': '筆',
  'frontend.local.component.tablepager.to': '-',
  'frontend.local.component.tablepager.total': '共',
  'frontend.local.component.modalpicksingleprojecttitle': '選擇專案',
  'frontend.local.component.modalpicksingleprojecthintsearchname': '輸入專案名稱進行搜尋',
  'frontend.local.component.modalpickprojectbuttonconfirm': '確認',
  'frontend.local.component.modalpickprojectbuttoncancel': '取消',

  'frontend.global.message.removeusertitle': '刪除這個使用者',
  'frontend.global.message.removeusercontent': '刪除這個使用者後, 他將無法進入系統, 確認後繼續',
  'frontend.global.message.removeprojecttitle': '刪除這個專案',
  'frontend.global.message.removeprojectcontent': '刪除這個專案後, 若有設定首頁封面, 則會被移除, 確認後繼續',
  'frontend.global.message.removeservicetitle': '刪除這個服務',
  'frontend.global.message.removeservicecontent': '即將刪除這個服務, 確認後繼續'
};

export default lang;
